module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-dashboard/optimizer/vehicle-size-dialog/vehicle-size-dialog.component.css
// module id = ./src/app/admin-dashboard/optimizer/vehicle-size-dialog/vehicle-size-dialog.component.css
// module chunks = main